module.exports = __webpack_public_path__ + "static/img/5.f10017a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Empresariales-Seguro-Colectivo/5.png
// module id = 8rRc
// module chunks = 0